/* ManageMyUserRenderer.js */

"use strict";
/* global Slick */
const SteveUiCore = require("@gluenetworks/steve_ui_core");
const ButtonControl = SteveUiCore.Control.Action.Button;
const InputTextControl = SteveUiCore.Control.Textfield.InputText;
const InputEmailControl = SteveUiCore.Control.Textfield.InputEmail;
const InputPasswordControl = SteveUiCore.Control.Textfield.InputPassword;
const InputCheckBoxControl = SteveUiCore.Control.Boolean.InputCheckbox;
const ComboBoxControl = SteveUiCore.Control.OptionSelection.Single.ComboBox;
const InputTextEditor = require("./cellEditors/InputTextEditor");
// const ActionGroupsEditor = require("./cellEditors/ActionGroupsEditor");
const DateEditor = require("./cellEditors/DateEditor");
const formatters = require("./cellFormaters");
const ShowSecretDialog = require("./veil/showSecret/ShowSecretComponent");

// Case PE-9876 - Temporarily rolling back User Credential changes
// const CheckboxControl = SteveUiCore.Control.Boolean.InputCheckbox;

const ActionItemComponent = require("../../commoncomponents/actionItemComponent/ActionItemComponent");
const _ = require("lodash");
const ErrorMapTranslation = require("../../commoncomponents/ErrorMapTranslation");
const ImageUploadComponent = require("../../commoncomponents/imageUpload/ImageUploadComponent");
const InputRadioControl = SteveUiCore.Control.OptionSelection.Single.InputRadio;

const NO_DATA_PLACEHOLDER_MSG = "No API Credentials Available";
// const GenerateAPICredentials = require("./section/GenerateAPICredentialComponent");

class ManageMyUserRenderer {
    constructor(model, uiUtils) {
        this._model = model;
        this._uiUtils = uiUtils;
        this._isDirty = false;
        this._labelElements = {};
        this._muf = this._model._muf;

        this._rootElem = document.createElement("manage-myuser-gl");
        this._rootElem.component = this._model;

        this._headerElem = document.createElement("h1");
        this._headerElem.innerText = "My Profile";
        this._rootElem.appendChild(this._headerElem);

        this._formElem = document.createElement("manage-myuser-form-gl");
        this._rootElem.appendChild(this._formElem);

        this._myProfileContainer = document.createElement("my-profile-container");

        // Case PE-9876 - Temporarily rolling back User Credential changes
        this._userCredentialContainer = document.createElement("user-credential-container");

        this._mySecurityContainer = document.createElement("my-security-container");
        this._myDashboardContainer = document.createElement("my-dashboard-container");

        this._myColorsContainer = document.createElement("my-color-container");

        this._fitTableSize = _.debounce(this._fitTableSize.bind(this), 400);
        // FORM FIELDS SETUP
        this._userName = new InputTextControl({darkTheme: true});
        this._first = new InputTextControl({darkTheme: true});
        this._last = new InputTextControl({darkTheme: true});
        this._email = new InputEmailControl({darkTheme: true});
        this._password1 = new InputPasswordControl({
            darkTheme: true,
            placeholder: "Enter a new password",
        });
        this._password2 = new InputPasswordControl({
            darkTheme: true,
            placeholder: "Verify password",
        });

        // Case PE-9876 - Temporarily rolling back User Credential changes
        // User Credential
        this._slickTableContainer = document.createElement("creds-table");
        this._slickWrapper = document.createElement("creds-table-wrapper");
        this._slickWrapper.appendChild(this._slickTableContainer);

        this._slickTable = undefined;
        this._columns = [
            {
                id: "name",
                width: 550,
                name: "Name",
                toolTip: "API Credential Name",
                field: "name",
                resizable: false,
                formatter: formatters.nameFormatter,
                editor: InputTextEditor,
            },
            {
                id: "clientId",
                width: 350,
                name: "Client ID",
                toolTip: "ClientID",
                field: "clientId",
                resizable: false,
            },
            // {
            //     id: "clientSecret",
            //     width: 370,
            //     name: "Secret",
            //     toolTip: "Secret",
            //     field: "clientSecret",
            //     resizable: false,
            //     headerCssClass: "centered"
            // },
            {
                id: "expirationDate",
                width: 110,
                name: "Expires On",
                toolTip: "Expires On",
                field: "expirationDate",
                resizable: false,
                formatter: formatters.dateFormatter,
                editor: DateEditor,
            },
            {
                id: "lastUsedOn",
                width: 110,
                name: "Last Used On",
                toolTip: "Last Used On",
                field: "lastUsedOn",
                resizable: false,
                formatter: formatters.dateFormatter,
            },
            {
                id: "createdOn",
                width: 110,
                name: "Created On",
                toolTip: "Created On",
                field: "createdOn",
                resizable: false,
                formatter: formatters.dateFormatter,
            },
        ];
        this._tableOptions = {
            editable: true,
            enableCellNavigation: true,
            enableColumnReorder: false,
            enableAsyncPostRender: true,
            asyncEditorLoading: false,
            asyncPostRenderDelay: 0,
            forceFitColumns: true,
            autoHeight: true,
            autoEdit: true,
            resizable: true,
            rowHeight: 45,
            fullWidthRows: true,
        };

        this._addNewRowButton = new ButtonControl({
            label: "Add API Credential +",
            active: true,
        });

        this._clickHandler = this._clickHandler.bind(this);
        this._fitTableSize = this._fitTableSize.bind(this);
        this._addNewRowAction = this._addNewRowAction.bind(this);

        this._onCellChangeAction = this._onCellChangeAction.bind(this);
        this._onRowCountChange = this._onRowCountChange.bind(this);
        this._onRowsChanged = this._onRowsChanged.bind(this);
        this._onBeforeEditCell = this._onBeforeEditCell.bind(this);

        // FORM SAVE/CANCEL BUTTONS SETUP
        this._buttonGroupContainer = document.createElement("button-group-container");
        this._saveButton = new ButtonControl({
            id: "save",
            label: "Save",
            disabled: true,
            active: true,
            darkTheme: true,
        });
        this._cancelButton = new ButtonControl({id: "cancel", label: "Cancel", disabled: true});
        this._buttonGroupContainer.appendChild(this._cancelButton.renderer.getRootElement());
        this._buttonGroupContainer.appendChild(this._saveButton.renderer.getRootElement());
        this._dashboardSection = undefined;
        this._imageUpload = new ImageUploadComponent({
            callback: this.model.updateImage,
            image: "",
            MUF: this.model._muf,
            noImageText: this._getUserInitials(),
            description: "Add a photo to help users identify you",
        });

        this._theme = new InputRadioControl({
            darkTheme: true,
            horizontal: true,
            options: [
                {
                    label: "Light",
                    value: "LIGHT",
                },
                {
                    label: "Dark",
                    value: "DARK",
                },
            ],
            value: "LIGHT",
        });

        this._newTaboption = new InputCheckBoxControl({
            darkTheme: true,
            labelShown: true,
            label: "Open solution links in a new tab",
            disabled: false,
        });

        this._enableFavouriteHotkeysCheckbox = new InputCheckBoxControl({
            darkTheme: true,
            labelShown: true,
            label: "Enable <span class='key main'>Alt</span> <span class='key'>&leftarrow;</span><span class='connect'></span><span class='key'>&rightarrow;</span> to navigate back and forth between favorite dashboards",
            disabled: false,
        });
        this._enableFavouriteShortcutsCheckbox = new InputCheckBoxControl({
            darkTheme: true,
            labelShown: true,
            label: "Enable <span class='key main'>Alt</span> <span class='key'>1</span><span class='connect'></span><span class='key'>9</span> to directly open favorite dashboard",
            disabled: false,
        });

        this._dashboardRotationPref = new ComboBoxControl({
            showFilter: false,
            adjustWidth: true,
            darkTheme: true,
        });
        this._dashboardRotationPref.options = [
            {label: "Off", value: 0},
            {label: "10 seconds", value: 10},
            {label: "30 seconds", value: 30},
            {label: "1 minute", value: 60},
            {label: "2 minutes", value: 120},
            {label: "5 minutes", value: 300},
        ];

        this._rowSelectedLabel = this._createLabel("Row Selection");
        this._explorerColorSelectedInput = this._createColorInput();
        this._colorPickerList = this._createColorList();
        this._rowHoverLabel = this._createLabel("Row Highlight");
        this._colorChart = this._createColorChart();

        // APPENDING DOM
        this._renderFormPair("Username", this._userName, this._myProfileContainer);
        this._renderFormPair("First Name", this._first, this._myProfileContainer);
        this._renderFormPair("Last Name", this._last, this._myProfileContainer);
        this._renderFormPair("Email", this._email, this._myProfileContainer);

        this._managedOrgs = document.createElement("div");
        this._managedOrgs.innerHTML = `<a class="manage-orgs-header" id="managedOrgsHeader">Managed Organizations (0)</a>
                                       <ul class='managed-orgs-list' id="managedOrgsList"></ul>`;
        // this._formElem.appendChild(this._managedOrgs);
        // this._managedOrgsHeader = this._formElem.querySelector('#managedOrgsHeader');
        // this._managedOrgsList = this._formElem.querySelector('#managedOrgsList');

        this._renderFormPair("Photo", this._imageUpload, this._myProfileContainer);

        // this._renderFormPair("Theme", this._theme);
        this._myDashboardContainer.appendChild(this._createThemeSection());
        this._myDashboardContainer.appendChild(this._createDashboardRotationPref());
        // this._renderFormPair("Dashboard rotation delay (seconds)", this._dashboardRotationPref);
        this._myDashboardContainer.appendChild(this._createEnableDisableHotkeysSection());
        this._myDashboardContainer.appendChild(this._createNewTabOptionSection());
        this._colorResetButton = new ButtonControl({
            id: "colorReset",
            label: "Reset",
            disabled: false,
            darkTheme: true,
        });
        this._myColorsContainer.appendChild(this._createColorExplorerSection());

        this._renderFormPair("Password", this._password1, this._mySecurityContainer);
        this._mySecurityContainer.appendChild(this._password2.renderer.getRootElement());
        this._labelElements.Password.classList.add("hidden");

        this._mySecurityContainer.appendChild(this._managedOrgs);
        this._managedOrgsHeader = this._mySecurityContainer.querySelector("#managedOrgsHeader");
        this._managedOrgsList = this._mySecurityContainer.querySelector("#managedOrgsList");

        // Case PE-9876 - Temporarily rolling back User Credential changes
        // this._createUserCredentialSection();

        this._formElem.appendChild(
            this._createSection(this._myProfileContainer, {
                title: "My Details",
                className: "sec-my-details",
                bordered: true,
            })
        );

        this._formElem.appendChild(
            this._createSection(this._mySecurityContainer, {
                title: "My Security",
                className: "sec-my-security",
                bordered: true,
            })
        );

        this._formElem.appendChild(
            this._createSection(this._userCredentialContainer, {
                title: "My API Credentials",
                className: "sec-api-creds",
                bordered: true,
            })
        );

        // const _dynamicAPICreds = new GenerateAPICredentials(this._model._ControlUserEntity, {uiUtils: this._uiUtils});
        this._userCredentialContainer.appendChild(this._slickWrapper);

        // this._formElem.appendChild(_dynamicAPICreds._renderer.rootElement);

        this._rootElem.appendChild(this._buttonGroupContainer);

        // ACTION ELEMENTS
        // Clear Preferences
        this._actionElem = document.createElement("manage-myuser-actions-gl");
        this._rootElem.appendChild(this._actionElem);
        let clearPrefsActionIcon = document.createElement("actionable-icon-gl");
        clearPrefsActionIcon.dataset.icon = "common.arrow";
        this._clearPreferencesAction = new ActionItemComponent(
            clearPrefsActionIcon,
            "Clear All Preferences"
        );
        let resendTwofaEmailActionIcon = document.createElement("actionable-icon-gl");
        resendTwofaEmailActionIcon.dataset.icon = "common.arrow";
        this._actionElem.appendChild(this._clearPreferencesAction.renderer.getRootElement());

        this._registerListeners();
    }
    // Case PE-9876 - Temporarily rolling back User Credential changes
    // _createUserCredentialSection() {
    //     this._userCredentialContainer.appendChild(
    //         this._enableCredentialCheckbox.renderer.rootElement
    //     );
    //     this._renderFormPair("Username", this._userCredUsername, this._userCredentialContainer);
    //     this._renderFormPair("Password", this._userCredPassword, this._userCredentialContainer);
    // }
    //
    // _enableCredentialChangeHandler() {
    //     this._userCredUsername.setDisabled(!this._enableCredentialCheckbox.value);
    //     this._userCredPassword.setDisabled(!this._enableCredentialCheckbox.value);
    // }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        this._uiUtils.clearMessage();
        let promArr = [];
        promArr.push(this._clearPreferencesAction.shutdown());
        // promArr.push(this._resendTwofaEmailAction.shutdown());
        promArr.push(this._imageUpload.shutdown());

        return Promise.all(promArr).then(() => {
            this._unregisterListeners();
            this._model = undefined;
            this._labelElements = null;
            this._rootElem.remove();
            this._rootElem = undefined;
            this._imageUpload = undefined;
            this._dashboardSection = undefined;
        });
    }

    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
        this._model.on(
            "SaveFailure",
            (this._saveFailureHandler = this._saveFailureHandler.bind(this))
        );
        this._model.on(
            "SaveSuccess",
            (this._saveSuccessHandler = this._saveSuccessHandler.bind(this))
        );
        this._model.on(
            "ClearPreferencesSuccess",
            (this._clearPrefsSuccess = this._clearPrefsSuccess.bind(this))
        );
        this._model.on(
            "ClearPreferencesError",
            (this._clearPrefsError = this._clearPrefsError.bind(this))
        );
        this._model.on(
            "SendTwoFaEmailSuccess",
            (this._sendTwoFaEmailSuccess = this._sendTwoFaEmailSuccess.bind(this))
        );
        this._model.on(
            "SendTwoFaEmailError",
            (this._sendTwoFaEmailError = this._sendTwoFaEmailError.bind(this))
        );
        this._model.on("SaveModelUpdated", (this._makeDirty = this._makeDirty.bind(this)));
        this._model.on("FormClean", (this._makePristine = this._makePristine.bind(this)));

        this._userName.on("UserValue", (this._userNameChange = this._userNameChange.bind(this)));
        this._first.on("UserValue", (this._firstChange = this._firstChange.bind(this)));
        this._last.on("UserValue", (this._lastChange = this._lastChange.bind(this)));
        this._email.on("UserValue", (this._emailChange = this._emailChange.bind(this)));
        this._password1.on("UserValue", (this._password1Change = this._password1Change.bind(this)));
        this._password2.on("UserValue", (this._password2Change = this._password2Change.bind(this)));
        this._newTaboption.on(
            "UserValue",
            (this._newTaboptionChange = this._newTaboptionChange.bind(this))
        );
        this._saveButton.on("UserClick", (this._saveUser = this._saveUser.bind(this)));
        this._colorResetButton.on(
            "UserClick",
            (this._resetThemePreferences = this._resetThemePreferences.bind(this))
        );
        this._cancelButton.on("UserClick", (this._cancelUpdate = this._cancelUpdate.bind(this)));
        this._managedOrgsHeader.addEventListener(
            "click",
            (this._toggleManagedOrgView = this._toggleManagedOrgView.bind(this))
        );
        this._clearPreferencesAction.on(
            "ActionItemClicked",
            (this._clearPreferences = this._clearPreferences.bind(this))
        );
        this._model.on("UserImage", this._userImageChange.bind(this));

        this._theme.on("UserValue", (this._onThemeChange = this._onThemeChange.bind(this)));
        this._enableFavouriteShortcutsCheckbox.on(
            "UserValue",
            (this._onEnableFavShortcutsChange = this._onEnableFavShortcutsChange.bind(this))
        );
        this._enableFavouriteHotkeysCheckbox.on(
            "UserValue",
            (this._onEnableFavHotkeysChange = this._onEnableFavHotkeysChange.bind(this))
        );
        this._dashboardRotationPref.on(
            "UserValue",
            (this._onRotationPrefChange = this._onRotationPrefChange.bind(this))
        );
        this._explorerColorSelectedInput.addEventListener("input", (e) => {
            this._colorSelectedChange(e.target.value, this);
        });

        // Case PE-9876 - Temporarily rolling back User Credential changes
        // this._enableCredentialCheckbox.on(
        //     "UserValue",
        //     (this._enableCredentialChangeHandler = this._enableCredentialChangeHandler.bind(this))
        // );
    }

    _registerSlickListeners() {
        this._model.on("DataUpdated", (this._onDataUpdated = this._onDataUpdated.bind(this)));

        this._addNewRowButton.on(
            "UserClick",
            (this._addNewRowAction = this._addNewRowAction.bind(this))
        );
        //this._slickTable.onAddNewRow.subscribe(this._addNewRowAction.bind(this));
        window.addEventListener("resize", this._fitTableSize);
        document.addEventListener("click", this._clickHandler);
        if (this._slickTable) {
            this._slickTable.onCellChange.subscribe(this._onCellChangeAction);
            this._slickTable.onBeforeEditCell.subscribe(this._onBeforeEditCell);
            this._slickDataVIew.onRowCountChanged.subscribe(this._onRowCountChange);
            this._slickDataVIew.onRowsChanged.subscribe(this._onRowsChanged);
        }
    }

    _unregisterSlickListeners() {
        this._model.removeListener("DataUpdated", this._onDataUpdated);
        this._addNewRowButton.removeListener("UserClick", this._addNewRowAction);
        window.removeEventListener("resize", this._fitTableSize);
        document.removeEventListener("click", this._clickHandler);

        if (this._slickTable) {
            this._slickTable.onCellChange.unsubscribe(this._onCellChangeAction);
            this._slickTable.onBeforeEditCell.subscribe(this._onBeforeEditCell);
            this._slickDataVIew.onRowCountChanged.unsubscribe(this._onRowCountChange);
            this._slickDataVIew.onRowsChanged.unsubscribe(this._onRowsChanged);
        }
    }

    _unregisterListeners() {
        this._model
            .removeAllListeners("Shutdown")
            .removeAllListeners("SaveFailure")
            .removeAllListeners("SaveSuccess")
            .removeAllListeners("ClearPreferencesSuccess")
            .removeAllListeners("ClearPreferencesError")
            .removeAllListeners("SendTwoFaEmailSuccess")
            .removeAllListeners("SendTwoFaEmailError")
            .removeAllListeners("SaveModelUpdated")
            .removeAllListeners("FormClean")
            .removeAllListeners("UserImage");

        this._userName.removeAllListeners("UserValue");
        this._first.removeAllListeners("UserValue");
        this._last.removeAllListeners("UserValue");
        this._email.removeAllListeners("UserValue");
        // this._enabletwofa.removeAllListeners('UserValue');
        this._password1.removeAllListeners("UserValue");
        this._password2.removeAllListeners("UserValue");

        this._saveButton.removeAllListeners("UserClick", this._saveUser);
        this._cancelButton.removeAllListeners("UserClick", this._cancelUpdate);
        this._clearPreferencesAction.removeAllListeners("ActionItemClicked");
        // this._resendTwofaEmailAction.removeAllListeners('ActionItemClicked');
        this._theme.removeAllListeners("UserValue");
        this._enableFavouriteShortcutsCheckbox.removeAllListeners("UserValue");
        this._enableFavouriteHotkeysCheckbox.removeAllListeners("UserValue");
        this._dashboardRotationPref.removeAllListeners("UserValue");
        this._newTaboption.removeAllListeners("UserValue", this._newTaboptionChange);

        // Case PE-9876 - Temporarily rolling back User Credential changes
        // this._enableCredentialCheckbox.removeAllListeners("UserValue");
    }
    _getUserInitials() {
        if (this._model._currentUserData) {
            return (
                this._model._currentUserData.first.charAt(0) +
                this._model._currentUserData.last.charAt(0)
            );
        }
        return "";
    }

    _getUserImage() {
        if (this._model._currentUserData) {
            return this._model._currentUserData.userImage;
        }
        return "";
    }
    _userNameChange(newVal) {
        this.model.updateUserSaveModelField("userName", newVal);
    }

    _userImageChange(newVal) {
        this.model.updateUserSaveModelField("userImage", newVal);
    }

    _firstChange(newVal) {
        this.model.updateUserSaveModelField("first", newVal);
    }

    _lastChange(newVal) {
        this.model.updateUserSaveModelField("last", newVal);
    }

    _emailChange(newVal) {
        this.model.updateUserSaveModelField("email", newVal);
    }

    _newTaboptionChange(newVal) {
        this._model._controlUser.setOpenSolutionsInNewTab(newVal);
        this._checkDirty();
    }

    _password1Change(newVal) {
        //If someone empties both fields manually, they are not invalid;
        if (_.isEmpty(newVal) && _.isEmpty(this._password2.value)) {
            this._password1.setInvalid(false);
            this._password2.setInvalid(false);
            this.model.removeUserSaveModelField("password");
        }
        //User typed both passwords accurately.
        else if (!_.isEmpty(newVal) && this._password2.value === newVal) {
            this._password1.setInvalid(false);
            this._password2.setInvalid(false);
            this.model.updateUserSaveModelField("password", newVal);
        }
        //User did not type both passwords accurately.
        else {
            this.model.removeUserSaveModelField("password");
            this._password2.setInvalid(true);
        }
    }

    _password2Change(newVal) {
        if (_.isEmpty(newVal) && _.isEmpty(this._password1.value)) {
            this._password1.setInvalid(false);
            this._password2.setInvalid(false);
            this.model.removeUserSaveModelField("password");
        }
        //User typed both passwords accurately.
        else if (!_.isEmpty(newVal) && this._password1.value === newVal) {
            this._password1.setInvalid(false);
            this._password2.setInvalid(false);
            this.model.updateUserSaveModelField("password", newVal);
        }
        //User did not type both passwords accurately.
        else {
            this.model.removeUserSaveModelField("password");
            this._password2.setInvalid(true);
        }
    }

    _disableButtons() {
        this._clearPreferencesAction.disable();
        // this._resendTwofaEmailAction.disable();
        this._saveButton.setDisabled(true);
        this._cancelButton.setDisabled(true);
    }

    _clearPreferences() {
        this._uiUtils.clearMessage();
        this._uiUtils.writeMessage("Clearing User Preferences");
        this.model.clearPreferences();
    }

    _resetThemePreferences() {
        const defaultVal = this.model._defaultColors.selected;
        this._explorerColorSelectedInput.value = defaultVal;
        this._colorSelectedChange(defaultVal);
        this._checkDirty();
    }

    _clearPrefsSuccess() {
        this._uiUtils.clearMessage();
        this._uiUtils.writeMessage("Preferences Cleared");
    }

    _clearPrefsError(err) {
        this._uiUtils.clearMessage();
        this._uiUtils.writeErrorMessage("Error clearing preferences: " + err.errorCode);
    }

    _sendTwofaEmail() {
        this._uiUtils.clearMessage();
        this._uiUtils.writeMessage("Resending 2FA email instructions");
        this.model.sendTwoFaEmail();
    }

    _sendTwoFaEmailSuccess() {
        this._uiUtils.clearMessage();
        this._uiUtils.writeMessage("2FA Email sent");
    }

    _sendTwoFaEmailError(err) {
        this._uiUtils.clearMessage();
        this._uiUtils.writeErrorMessage("Error sending 2FA email: " + err.errorCode);
    }

    _renderFormPair(labelName, component, container = this._formElem) {
        let labelElem = document.createElement("label");
        labelElem.innerText = labelName;
        let cmpntElem = component.renderer.getRootElement();
        this._labelElements[labelName] = labelElem;
        container.appendChild(labelElem);
        container.appendChild(cmpntElem);
    }

    _makeDirty() {
        this._saveButton.setDisabled(false);
        this._cancelButton.setDisabled(false);
        this._renderAvailableActions(true);
        this._isDirty = true;
    }

    _makePristine() {
        this._saveButton.setDisabled(true);
        this._cancelButton.setDisabled(true);

        this._password1.setInvalid(false);
        this._password2.setInvalid(false);
        this._userName.setInvalid(false);
        this._first.setInvalid(false);
        this._last.setInvalid(false);
        this._updatePrefsData(this._model._controlUser);
        this._renderAvailableActions();
        this._isDirty = false;
    }

    _saveUser() {
        this._disableButtons();

        //veil check
        let veilMsg = "";
        let checkList = [
            {id: "userName", label: "Username: "},
            {id: "first", label: "First Name: "},
            {id: "last", label: "Last Name: "},
            {id: "email", label: "Email: "},
        ];
        checkList.forEach((entry) => {
            if (this._model._saveModel.user[entry.id]) {
                veilMsg += entry.label + this._model._saveModel.user[entry.id] + "\n";
            }
        });

        //something to message?
        if (veilMsg.length > 1) {
            return (
                this._muf
                    .displayConfirmation(veilMsg, {
                        title: "Please confirm the information is accurate.",
                        confirmDetails: {
                            text: "Confirm",
                            type: "additive",
                        },
                        rejectDetails: {
                            text: "Cancel",
                            type: "text",
                        },
                        notDismissable: true,
                    })
                    .then(() => {
                        // Save user base
                        return (
                            this.model
                                .saveUserBase()
                                // Save user control
                                .then(() => {
                                    return this.model.saveUserControl();
                                })
                                // Save color preferences in user preferences
                                .then(() => {
                                    return this.model.saveUserThemes();
                                })
                                .then(() => {
                                    return this._saveSuccessHandler();
                                })
                        );
                    })
                    // Could cancel out of veil, same behavior as hitting cancel on main view
                    .catch((err) => {
                        if (err.userRejected) {
                            this._cancelUpdate();
                            return Promise.resolve();
                        } else {
                            return this._muf.displayError(err).catch(() => Promise.resolve());
                        }
                    })
            );
        } else {
            // Save user base
            return this.model
                .saveUserBase()
                .then(() => {
                    // Save user control
                    this.model.saveUserControl();
                })
                .then(() => {
                    // Save color preferences in user preferences
                    this.model.saveUserThemes();
                })
                .then(() => {
                    return this._saveSuccessHandler();
                })
                .catch((err) => {
                    return this._muf.displayError(err).catch(() => Promise.resolve());
                });
        }
    }

    async _cancelUpdate() {
        this._makePristine();
        await this.render();
    }

    _saveSuccessHandler() {
        return this._uiUtils
            .showMessageDialog({
                message:
                    "You have made changes to your user profile. The browser will be refreshed.",
                confirmButtonName: "OK",
            })
            .then(() => {
                this.model.router.reload();
            });
    }

    _saveFailureHandler(err) {
        //TODO Figure out all the errors we used to parse, then parse em and show them on the screen!
        //this._uiUtils.writeErrorMessage("Error saving user: " + err.errorCode);
        //let appErr = err.error;
        switch (err.errorCode) {
            case "ValidationError":
                if (_.isPlainObject(err.errorDetails)) {
                    const errorNames = Object.keys(err.errorDetails);
                    this._uiUtils.writeErrorMessage("Error saving user:");
                    errorNames.forEach((propNameErr, index) => {
                        if (_.has(this, "_" + propNameErr)) {
                            const defaultText = ErrorMapTranslation.User.default_entry;
                            const errorMessages = err.errorDetails[propNameErr].messages;
                            let errorText =
                                Array.isArray(errorMessages) && errorMessages.length > 0
                                    ? errorMessages[0]
                                    : defaultText;
                            errorText = errorText.replace(/"first"/, '"First Name"');
                            errorText = errorText.replace(/"last"/, '"Last Name"');
                            if (index === errorNames.length - 2) {
                                errorText = errorText + " and";
                            } else if (index !== errorNames.length - 1) {
                                errorText = errorText + ",";
                            }
                            this._uiUtils.writeErrorMessage(errorText);
                        }
                    });
                }
                break;
            case "NotAuthorized":
                this._uiUtils.writeErrorMessage(ErrorMapTranslation.Common.NotAuthorized);
                break;
            default:
                break;
        }
        this._makeDirty();
    }

    _buildManagedOrgs() {
        let listElem = this._managedOrgsList;
        let headerElem = this._managedOrgsHeader;
        while (listElem && listElem.firstChild) {
            listElem.removeChild(listElem.firstChild);
        }

        let orgNameList = [];

        Object.keys(this._model._currentUserData.authorizedOrganizations).forEach((orgId) => {
            orgNameList.push(this._model._currentUserData.authorizedOrganizations[orgId].name);
        });

        orgNameList.sort().forEach((orgName) => {
            let listItem = document.createElement("li");
            listItem.innerText = orgName;
            listElem.appendChild(listItem);
        });
        headerElem.innerText = "Managed Organizations (" + orgNameList.length + ")";
        listElem.style.display = "none";
    }

    _toggleManagedOrgView() {
        let listElem = document.getElementById("managedOrgsList");

        if (listElem.style.display === "none") {
            listElem.style.display = "";
        } else {
            listElem.style.display = "none";
        }
    }

    _renderAvailableActions(disableFlag) {
        if (disableFlag) {
            this._clearPreferencesAction.disable();
        } else {
            this._clearPreferencesAction.enable();
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this.model.whenModelIsReady().then(() => {
            if (this.model.canAccessDashboard && !this._dashboardSection) {
                this._dashboardSection = this._createSection(this._myDashboardContainer, {
                    title: "My Dashboards",
                    className: "sec-my-dashboard",
                    bordered: true,
                });
                this._formElem.appendChild(this._dashboardSection);
            }

            if (!this._colorsSection) {
                this._colorsSection = this._createSection(this._myColorsContainer, {
                    title: "My Colors",
                    className: "sec-my-colors",
                    bordered: true,
                });
                this._formElem.appendChild(this._colorsSection);
            }

            // api credentials - start
            if (this._model.canCreateAPICredentials) {
                this.addAdditionalColumns();
                this._toggleNoDataPlaceholder(_.isEmpty(this._model.getSlickData()));
                // BEGIN data table preparation section
                this._slickDataVIew = new Slick.Data.DataView();
                this._slickDataVIew.setItems(this._model.getSlickData()); //(this._getModelData());
                this._slickTable = new Slick.Grid(
                    this._slickTableContainer,
                    this._slickDataVIew,
                    this._columns,
                    this._tableOptions
                );

                this._slickTable.setSelectionModel(new Slick.RowSelectionModel());
                this._slickTableContainer.appendChild(this._createNoDataPlaceholder());
                this._slickWrapper.appendChild(
                    this._uiUtils.wrapElement(
                        this._addNewRowButton.renderer.getRootElement(),
                        null,
                        "add-new-row"
                    )
                );

                this._hideShowAddNewCredential();
            } else {
                document.querySelector(".sec-api-creds").classList.add("hide");
            }
            // api credentials - end

            this._updatePrefsData(this._model._controlUser);
            this._userName.setValue(this.model.currentUserData.userName);
            this._first.setValue(this.model.currentUserData.first);
            this._last.setValue(this.model.currentUserData.last);
            this._email.setValue(this.model.currentUserData.email);
            this._password1.setValue(null);
            this._password2.setValue(null);
            // this._enabletwofa.setValue(!_.isEmpty(this.model.currentUserData.secret));

            this._imageUpload.stringValue = this._getUserInitials();
            this._imageUpload.emit("UpdateImage", this._model._controlUser.image);

            this._first.disabled = !this.model.isFirstEditable;
            this._last.disabled = !this.model.isLastEditable;
            this._email.disabled = !this.model.isEmailEditable;
            if (this.model.isSamlUser) {
                this._userName.disabled = true;
                this._password1.visible = false;
                this._password2.visible = false;
                this._labelElements.Username.innerText = "User Name (SAML)";
                this._labelElements.Password.innerText = "Password Managed by SAML";
                this._labelElements.Password.classList.remove("hidden");
            } else if (this.model.isOauthUser) {
                this._userName.disabled = true;
                this._password1.visible = false;
                this._password2.visible = false;
                this._labelElements.Username.innerText = "User Name (OAuth)";
                this._labelElements.Password.innerText = "Password Managed by OAuth";
                this._labelElements.Password.classList.remove("hidden");
            } else if (this.model.isLdapUser) {
                this._userName.disabled = true;
                this._password1.visible = false;
                this._password2.visible = false;
                this._labelElements.Username.innerText = "User Name (LDAP)";
                this._labelElements.Password.innerText = "Password Managed by LDAP";
                this._labelElements.Password.classList.remove("hidden");
            } else if (this.model.isRadiusUser) {
                this._userName.disabled = true;
                this._password1.visible = false;
                this._password2.visible = false;
                this._labelElements.Username.innerText = "User Name (RADIUS)";
                this._labelElements.Password.innerText = "Password Managed by RADIUS";
                this._labelElements.Password.classList.remove("hidden");
            } else {
                this._userName.disabled = false;
                this._password1.visible = true;
                this._password2.visible = true;
                this._labelElements.Password.innerText = "Password";
                this._labelElements.Password.classList.add("hidden");
            }

            this._newTaboption.setValue(this._model._controlUser.openSolutionsInNewTab);

            this._loadThemesData();

            this._buildManagedOrgs();
            this._renderAvailableActions();
            this._makePristine();

            this._registerSlickListeners();
            this._fitTableSize();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    //TODO Private Render Methods here
    _updatePrefsData(userData) {
        this._theme.setValue(userData.theme);
        this._enableFavouriteHotkeysCheckbox.setValue(userData.enableFavoriteHotkeys);
        this._enableFavouriteShortcutsCheckbox.setValue(userData.enableFavoriteShortcuts);
        this._dashboardRotationPref.setValue(userData.favoriteRotationDelay);
    }

    _loadThemesData() {
        const colors = this._model._themeExplorer.colors;
        this._explorerColorSelectedInput.value = colors.selected;
        this._updateColorChart();
    }

    _updateColorChart() {
        const chartColHoverEl = document.getElementById("chartColHover");
        const themeColorHover = _.get(this._model._themeExplorer, "colors.hover");
        if (chartColHoverEl && themeColorHover) {
            chartColHoverEl.style.backgroundColor = themeColorHover;
        }
    }

    _createDashboardRotationPref() {
        const _rotationPrefSection = document.createDocumentFragment();

        const _rotationPrefWrapper = document.createElement("div");
        // const labelElem = document.createElement("label");
        // labelElem.innerText = "Delay (seconds)";
        // _rotationPrefWrapper.appendChild(labelElem);
        _rotationPrefWrapper.appendChild(this._dashboardRotationPref.renderer.getRootElement());

        _rotationPrefSection.appendChild(_rotationPrefWrapper);

        return this._createSection(_rotationPrefSection, {
            title: "Rotation Delay",
            className: "rotation-section",
            bordered: false,
        });
    }

    _createColorExplorerSection() {
        const _explorerSection = document.createDocumentFragment();

        const _defaultExplorerWrapper = document.createElement("div");

        _defaultExplorerWrapper.appendChild(this._rowSelectedLabel);
        _defaultExplorerWrapper.appendChild(this._explorerColorSelectedInput);
        _defaultExplorerWrapper.appendChild(this._colorResetButton.renderer.getRootElement());
        _defaultExplorerWrapper.appendChild(this._colorPickerList);
        _defaultExplorerWrapper.appendChild(this._rowHoverLabel);
        _defaultExplorerWrapper.appendChild(this._colorChart);

        _explorerSection.appendChild(_defaultExplorerWrapper);

        return this._createSection(_explorerSection, {
            title: "",
            className: "color-explorer-section",
            bordered: false,
        });
    }

    _createThemeSection() {
        const _defaultThemeSection = document.createDocumentFragment();

        const _defaultThemeWrapper = document.createElement("div");
        _defaultThemeWrapper.appendChild(this._theme.renderer.getRootElement());

        _defaultThemeSection.appendChild(_defaultThemeWrapper);

        return this._createSection(_defaultThemeSection, {
            title: "Theme",
            className: "default-theme-section",
            bordered: false,
        });
    }

    _createNewTabOptionSection() {
        const _newTabSection = document.createDocumentFragment();
        const _newTabWrapper = document.createElement("div");
        _newTabWrapper.appendChild(this._newTaboption.renderer.getRootElement());
        _newTabSection.appendChild(_newTabWrapper);
        return this._createSection(_newTabSection, {
            title: "Widgets",
            className: "new-tab-option-section",
            bordered: false,
        });
    }

    _createEnableDisableHotkeysSection() {
        const _enableDisableHotkeysSection = document.createDocumentFragment();

        const _enableDisableHotkeysWrapper = document.createElement("div");
        _enableDisableHotkeysWrapper.appendChild(
            this._enableFavouriteHotkeysCheckbox.renderer.getRootElement()
        );
        _enableDisableHotkeysWrapper.appendChild(
            this._enableFavouriteShortcutsCheckbox.renderer.getRootElement()
        );

        _enableDisableHotkeysSection.appendChild(_enableDisableHotkeysWrapper);

        return this._createSection(_enableDisableHotkeysSection, {
            title: "Keyboard Shortcuts",
            className: "hotkeys-section",
            bordered: false,
        });
    }

    _createSection(content, options = {}) {
        const section = document.createElement("section");
        section.className = options.className || "";
        section.classList.toggle("bordered", !!options.bordered);

        if (options.title) {
            const title = document.createElement("h2");
            title.innerText = options.title;
            section.appendChild(title);
        }
        section.appendChild(content);
        return section;
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onShutdown() {
        this._shutdown();
    }

    _onThemeChange(val) {
        this._model._controlUser.setTheme(val);
        this._checkDirty();
    }

    _onEnableFavShortcutsChange(val) {
        this._model._controlUser.setEnableFavoriteShortcuts(val);
        this._checkDirty();
    }

    _onEnableFavHotkeysChange(val) {
        this._model._controlUser.setEnableFavoriteHotkeys(val);
        this._checkDirty();
    }

    _onRotationPrefChange(val) {
        if (!val && val !== 0) {
            val = 0;
        }
        if (val >= 0 && val <= 3600) {
            this._model._controlUser.setFavoriteRotationDelay(val);
            this._checkDirty();
        }
        // } else {
        //     this._uiUtils.writeErrorMessage("Invalid Value: Dashoard rotation delay must be between 0 - 3600");
        // }
    }

    _colorSelectedChange(val) {
        if (this._model._themeExplorer.colors.selected !== val) {
            this._model._themeExplorer.colors.selected = val;
            this._model._themeExplorer.colors.hover = this._calculateHover(val);
            this._updateColorChart();
            this._makeDirty();
            this._checkDirty();
        }
    }
    /*
    _colorHoverChange(val,that) {
      if(that._model._themeExplorer.colors.hover !== val) {
          `that._model._themeExplorer.colors.hover = val;
          that._makeDirty();
          that._checkDirty();`
      }
    }
 */

    _calculateHover(selColor, delta = 33) {
        const red = Math.min(parseInt(selColor.slice(1, 3), 16) + delta, 255).toString(16);
        const green = Math.min(parseInt(selColor.slice(3, 5), 16) + delta, 255).toString(16);
        const blue = Math.min(parseInt(selColor.slice(5, 7), 16) + delta, 255).toString(16);

        return `#${red}${green}${blue}`;
    }

    _clickHandler(e) {
        if (this._slickTable) {
            //if we click delete column
            const target = e.target;
            if (
                target.getAttribute("role") === "button" &&
                target.dataset.action === "delete" &&
                target.dataset.uuid
            ) {
                this._deleteItem(target.dataset.uuid, target.dataset.id);
            }
            this._saveAndCloseEditCellAction(e);
        }
    }

    _deleteItem(clientId, id) {
        const item = this._slickDataVIew.getItemById(id);

        const deleteConfirmation = (item) => {
            const deletedItemName = _.get(item, "name", "Unknown");
            const deleteMessage = `Are you sure you want to permanently delete "${deletedItemName}"?`;

            return this._uiUtils.showDeleteConfirmDialog({
                message: deleteMessage,
                confirmButtonName: "Confirm",
                cancelButtonName: "Cancel",
            });
        };

        return deleteConfirmation(item)
            .then(() => this.model.deleteCredential(clientId))
            .then(() => {
                this._slickDataVIew.deleteItem(id);
                this._hideShowAddNewCredential();
            })
            .catch((error) => {
                error && console.log(error);
            });
    }

    _fitTableSize() {
        if (this._slickTable) {
            this._slickTable.resizeCanvas();
        }
    }
    _addNewRowAction(/*e, args*/) {
        const itemsNames = this._slickDataVIew.getItems().map((i) => i.name);
        const name = this.generateName(itemsNames);
        this.model.createCredsItem(name);
    }

    async _onCellChangeAction(e, row) {
        const updatedColumnObj = this._columns[row.cell];

        await this._model._updateControlUserEntity(row.item, updatedColumnObj.field);
        const item = this._slickDataVIew.getItemByIdx(row.row);
        // const item = row.item;

        // slickData.updateItem(row.row, row.item);
        this._checkDirty();
        if (this._model._controlUser.isDirty()) {
            item.dirty = true;
            this._slickTable.invalidateAllRows();
            this._slickTable.resizeCanvas();
        }
    }
    _onRowCountChange(event, {/*previous,*/ current}) {
        this._slickTable.invalidateAllRows();
        this._slickTable.resizeCanvas();
        this._toggleNoDataPlaceholder(!current);
    }

    _onRowsChanged() {
        // this._setActionButtonsAvailability();
        this._checkDirty();
    }

    _onBeforeEditCell(e, {item, column /*, row, cell, grid*/}) {
        //allow to edit according to the following conditions:
        const allowConditions = [
            !(column.field === "dataType" && !item.isNew), //do not allow change dataType if item is not new
        ];

        return allowConditions.every(Boolean);
    }

    _toggleNoDataPlaceholder(state) {
        this._slickTableContainer.classList.toggle("empty", state);
    }

    _onDataUpdated() {
        if (!_.isEmpty(this._model._visibleCred)) {
            const showDialog = new ShowSecretDialog(this._model._visibleCred);
            this._model._muf.displayCustom(showDialog, {notDismissable: false}).catch((error) => {
                if (error && !error.userRejected) {
                    console.log("Error in Reveal: _revealItem()", error);
                }
            });
        }

        this._slickDataVIew.setItems(this._model.getSlickData());
        this._hideShowAddNewCredential();
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    // TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    _checkDirty() {
        if (this._model._controlUser.isDirty() || this._isDirty) {
            this._saveButton.setDisabled(false);
            this._cancelButton.setDisabled(false);
            this._renderAvailableActions(true);
        } else if (!this._isDirty) {
            this._saveButton.setDisabled(true);
            this._cancelButton.setDisabled(true);
            this._renderAvailableActions(false);
        }
    }

    _createLabel(labelName) {
        let labelElem = document.createElement("label");
        labelElem.innerText = labelName;

        return labelElem;
    }

    _createColorInput() {
        const colorInput = document.createElement("input");
        colorInput.classList.add("colorInput");
        colorInput.setAttribute("type", "color");
        colorInput.setAttribute("list", "colorList");
        return colorInput;
    }

    _createColorList() {
        const colorList = document.createElement("datalist");
        let contents = `<datalist id="colorList">`;

        colorList.setAttribute("id", "colorList");
        for (const option of this.model._safePalette) {
            contents += `<option>${option}</option>`;
        }
        colorList.innerHTML = `${contents}</datalist>`;
        return colorList;
    }

    _createColorChart() {
        const colorChart = document.createElement("div");

        colorChart.setAttribute("id", "colorChart");
        colorChart.innerHTML = `<span id="chartColHover"></span>`;
        return colorChart;
    }

    _createNoDataPlaceholder() {
        const noDataPlaceholder = document.createElement("div");
        noDataPlaceholder.classList.add("no-data-placeholder");
        noDataPlaceholder.innerText = NO_DATA_PLACEHOLDER_MSG;
        return noDataPlaceholder;
    }

    _saveAndCloseEditCellAction(e) {
        //do nothing if no active editors
        if (this._slickTable && !this._slickTable.getEditorLock().isActive()) {
            return false;
        }

        //get event bubbling path
        const path = e.path || e.composedPath();

        //check if click was outside of current editing cell
        let outsideClick = true;
        _.each(path, (element) => {
            const elHasClass = (className) =>
                element.classList && element.classList.contains(className);

            if (elHasClass("slick-cell")) {
                const cellHasActiveEditor = elHasClass("active") && elHasClass("editable");
                outsideClick = !cellHasActiveEditor;
                return false;
            }

            if (element === this._slickTableContainer) {
                return false;
            }
        });

        if (outsideClick) {
            this._slickTable.getEditorLock().commitCurrentEdit();
        }
    }

    addAdditionalColumns() {
        // if (_.isEmpty(this._columns.find((i) => i.id === "actionGroupId"))) {
        // const actionGroups = {
        //     id: "actionGroupId",
        //     width: 300,
        //     name: "Role",
        //     toolTip: "Role",
        //     field: "actionGroupId",
        //     resizable: true,
        //     editor: ActionGroupsEditor,
        //     values: this._model._rolesArray,
        //     formatter: formatters.actionGroupFormatter,
        // };

        // this._columns.splice(3, 0, actionGroups);
        // }
        if (_.isEmpty(this._columns.find((i) => i.id === "createdBy"))) {
            const createdBy = {
                id: "createdBy",
                width: 100,
                name: "Created By",
                toolTip: "Created By",
                field: "createdBy",
                resizable: true,
                formatter: formatters.createdByFormatter,
                value: this._model._controlUser.getUsername(),
            };
            this._columns.splice(7, 0, createdBy);
        }

        if (_.isEmpty(this._columns.find((i) => i.id === "action"))) {
            const canReveal =
                this._model._currentUserData.authorizedActions.indexOf("revealCredentials") > -1;
            const actions = {
                id: "action",
                width: 100,
                name: "Action",
                toolTip: "Action",
                field: "action",
                resizable: false,
                cssClass: `centered ${canReveal ? "can-reveal" : "no-reveal"}`,
                headerCssClass: "centered",
                formatter: formatters.actionButtonsFormatter,
            };

            this._columns.splice(8, 0, actions);
        }
    }

    _hideShowAddNewCredential() {
        if (this._model._slickData.length >= 3) {
            this._addNewRowButton.renderer.getRootElement().classList.add("hide");
        } else {
            this._addNewRowButton.renderer.getRootElement().classList.remove("hide");
        }
    }

    generateName(existingNames) {
        let baseName = "New API Credential";
        let count = 2;
        let newName = baseName;
        while (existingNames.includes(newName)) {
            newName = `${baseName} ${count}`;
            count++;
        }
        return newName;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = ManageMyUserRenderer;
